import { useEffect } from 'react'

const addedFilters = new Set()

const addSVGFilters = (filterId, svgContent) => {
  if (addedFilters.has(filterId)) {
    return
  }

  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  svg.style.display = 'none'
  svg.setAttribute('data-filter-id', filterId)
  svg.innerHTML = svgContent
  
  document.body.appendChild(svg)
  addedFilters.add(filterId)
}

export const useSVGFilters = (filterId, svgContent) => {
  useEffect(() => {
    addSVGFilters(filterId, svgContent)
  }, [filterId, svgContent])
}
